<template>

    <div class="w-full">
        <vx-card id="table"  class="vs-con-loading__container">

            <h4 class="mb-3">Channels</h4>

            <vs-table ref="table" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="channel_id">ID</vs-th>
                    <vs-th sort-key="epg_provider_name" v-if="providerNameColumn">Provider name</vs-th>
                    <vs-th sort-key="last_entry">Last entry</vs-th>
                    <vs-th sort-key="thumbnail_percentage">Thumbnail percentage</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td style="width: 80px; overflow: hidden">
                                <img v-if="data[index].icon.length > 0" style="height: 40px" :src="data[index].icon" :alt="data[index].name">
                            </vs-td>

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                            <vs-td :data="data[index].channel_id">
                                {{ data[index].channel_id }}
                            </vs-td>

                            <vs-td v-if="providerNameColumn" :data="data[index].epg_provider_name">
                                {{ data[index].epg_provider_name }}
                            </vs-td>

                            <vs-td :data="data[index].last_entry">
                                {{ moment(data[index].last_entry).format('YYYY/MM/DD HH:mm') }}
                            </vs-td>

                            <vs-td :data="data[index].thumbnail_percentage">
                                {{ data[index].thumbnail_percentage }}
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>
        </vx-card>

    </div>

</template>
<script>

    export default {
        props: {
            url: {
                type: String,
                required: true
            },
            providerNameColumn: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {

                itemsPerPage: 20,
                isMounted: false,

                channels: []
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get(this.url)
                loadPromise.then(function(response) {
                    thisIns.channels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.channels
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }
    }

</script>
